import { gql } from '@apollo/client';

export const RatificationActionsBasicFields = gql`
  fragment RatificationActionsBasicFields on RatificationActionType {
    id
    actionType
    comment
    createdAt
    channel
    responded
  }
`;

export const ReviewDocumentsManagerFields = gql`
  fragment ReviewDocumentsManagerFields on ReviewDocumentsManagerType {
    id
    requiresOc
    requiresHes
    requiresPaymentStatus
    requiresPortalScreenshot
    hasReceptionAcknowledgment
    ocReviewState
    hesReviewState
    paymentStatusReviewState
    portalScreenshotReviewState
    receptionAcknowledgmentReviewState
    createdAt
  }
`;
